<span class="channel-status" [ngClass]="{
        paused: currentChannelStatus == ChannelStatus.PAUSED,
        completed: currentChannelStatus == ChannelStatus.COMPLETED,
        live: currentChannelStatus == ChannelStatus.LIVE,
        approved: currentChannelStatus == ChannelStatus.APPROVED,
        rejected: currentChannelStatus == ChannelStatus.REJECTED,
        cancelled: currentChannelStatus == ChannelStatus.CANCELLED,
        pending: isPending(currentChannelStatus),
        draft: currentChannelStatus == ChannelStatus.DRAFT
    }">
    <span [matTooltip]="buildChannelStatusToolTip(currentChannelStatus)"
        style="background: transparent; cursor: pointer; padding: 4px; text-align: center">
    </span>
</span>